import { Component } from 'react';
import classNames from 'classnames';
import MathQuill from 'legacy-lib/mathquill-patch';
import _ from 'lodash';
import PropTypes from 'prop-types';

/** Components */
import MultiLineNav from './MultiLineNav';

class MathquillInput extends Component {
  state = {
    mq: null,
  };

  initMathquill = async (ref) => {
    const field = MathQuill.MathField(ref, {
      autoOperatorNames: 'log cos sin tan sec cot mol',
    });
    // FIXME: If the equation has invalid latex (eg empty text node)
    // field.latex(this.equation()) will throw
    // Uncaught TypeError: Cannot read property 'nodeType' of null
    // and this.state.mq will be null
    this.setState({
      mq: field ? field.latex(this.equation()) : this.state.mq,
    });
  };

  componentDidUpdate() {
    if (this.isActive()) {
      this.state.mq?.focus(); // FIXME: breaks on invalid latex
    }
  }

  cmd = (value) => {
    this.state.mq.cmd(value).focus(); // FIXME: breaks on invalid latex
  };

  equation = () => {
    return this.props.equations[this.props.index];
  };

  handleClick = () => {
    this.props.onClick(this.props.index);
  };

  handleKeyUp = (e) => {
    if (!this.isActive()) {
      e.preventDefault();
      return;
    }
    this.props.onKeyUp(e);
  };

  isActive = () => {
    return this.props.activeEquation === this.props.index;
  };

  keystroke = (value) => {
    this.state.mq.keystroke(value).focus(); // FIXME: breaks on invalid latex
  };

  latex = (value) => {
    // Getter + setter used by EquationEditor as `refs.activeInput.latex`
    if (!_.isEmpty(value)) {
      return this.state.mq.latex(value); // FIXME: breaks on invalid latex
    }
    return this.state.mq.latex();
  };

  typedText = (value) => {
    this.state.mq.typedText(value).focus(); // FIXME: breaks on invalid latex
  };

  write = (value) => {
    this.state.mq.write(value).focus(); // FIXME: breaks on invalid latex
  };

  render() {
    const classes = classNames({
      'mathquill-input': true,
      active: this.isActive(),
    });

    let multiLineNav = '';

    if (this.props.showNavWhenActive && this.isActive()) {
      multiLineNav = (
        <MultiLineNav
          index={this.props.index}
          equations={this.props.equations}
          onNavUp={this.props.onNavUp}
          onNavDown={this.props.onNavDown}
        />
      );
    }

    return (
      <div className={classes} onClick={this.handleClick}>
        <span
          ref={this.initMathquill}
          className="math-field"
          onKeyUp={this.handleKeyUp}
        />
        {multiLineNav}
      </div>
    );
  }
}

MathquillInput.propTypes = {
  activeEquation: PropTypes.number,
  equations: PropTypes.arrayOf(PropTypes.string),
  index: PropTypes.number,
  onClick: PropTypes.func,
  onKeyUp: PropTypes.func,
  onNavDown: PropTypes.func,
  onNavUp: PropTypes.func,
  showNavWhenActive: PropTypes.bool,
};

MathquillInput.defaultProps = {
  showNavWhenActive: true,
};

export default MathquillInput;
